import React, { Component } from 'react';

import {
  Layout,
  Modal,
  Toast,
  TextField,
  Select,
  Button,
  FormLayout,
  BlockStack,
  Icon,
  // Popover,Card,Banner,Thumbnail,
  Text,
} from "@shopify/polaris";
import {
  CirclePlusMajor,CancelSmallMinor
} from '@shopify/polaris-icons';

import ImageGalleryShow from '../../../../../components/ImageGalleryShow';

import { reqGetPackageDetail,reqPostCreatePackageOrder } from '../../../../../api';
import intl from '../../../../../i18n/intl';
import "./index.css";

class PackageDetailModal extends Component {
    constructor(props) {
      super(props);
      this.state = {
        ModalShow: (props.show===undefined)?false:props.show,
        loadingPage: false,
        handleLoading: false,
        
        Title: '',
        ImageUrl: '',
        ImageList: [],
        labelArray: [],
        valuesArray: [
          [],
          [],
          []
        ],
        variants: [],

        // 选择的三个属性
        selectOptionOne: '',
        selectOptionTwo: '',
        selectOptionThree: '',

        currentVariantId: 0,
        currentVariantTitle: '',
        currentVariantPrice: '',
        orderQuantity: 0,
        minBuyNumber: 100,

        // 下单数组
        createOrderArray: [],
        cartViewHtml: <tr></tr>,
        Subtotal: 0,
        leavingModalActive: false,
      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        ModalShow: (nextProps.show===undefined)?false:nextProps.show,
        loadingPage: false,
        handleLoading: false,

        Title: '',
        ImageUrl: '',
        ImageList: [],
        labelArray: [],
        valuesArray: [
          [],
          [],
          []
        ],
        variants: [],

        // 选择的三个属性
        selectOptionOne: '',
        selectOptionTwo: '',
        selectOptionThree: '',

        currentVariantId: 0,
        currentVariantTitle: '',
        currentVariantPrice: '',
        orderQuantity: 0,
        minBuyNumber: 100,

        // 下单数组
        createOrderArray: [],
        cartViewHtml: <tr></tr>,
        Subtotal: 0,
        leavingModalActive: false,

      },()=>{
        if(this.props.id !== 0){
          this.initData();
        }
      });
    }

    //进入页面调用接口
    componentDidMount () {
      if(this.props.id !== 0){
        this.initData();
      }
    }

    //提示弹窗
    toggleToast = (showToastText, showToastIserror=false) => {
      this.setState(({ showToast }) => ({
        showToast: !showToast,
        showToastText: showToastText,
        showToastIserror: showToastIserror
      }));
    };

    // 初始化数据
    initData = async() => {
      this.setState({ loadingPage: true });
      const params = {
        id: this.props.id,
      }
      const response = await reqGetPackageDetail(params)
      if(response.code==='200'){
        let getData = response.data;
        // console.info(getData);
        if(getData !== ''){
          // 初始化数组
          let firstInit = getData.first;

          this.setState({
            loadingPage: false,
            Title: getData.title,
            ImageUrl: (getData.image_url === '') ? '/default_image.png' : getData.image_url,
            ImageList: getData.image_list,
            labelArray: getData.labels,
            valuesArray: getData.values,
            variants: getData.variants,

            // 选择的三个属性
            selectOptionOne: firstInit.one,
            selectOptionTwo: firstInit.two,
            selectOptionThree: firstInit.three,

            currentVariantId: firstInit.id,
            currentVariantTitle: firstInit.title,
            currentVariantPrice: firstInit.price,
            orderQuantity: getData.number,
            minBuyNumber: getData.number,
          });
        }
        
      }else{
        this.setState({ loadingPage: false });
        this.toggleToast(response.msg);
        // 关闭弹窗
        this.handleChangeModal();
      }
    }

    // 弹窗控制
    handleChangeModal = () =>{
      this.setState({
        ModalShow:!this.state.ModalShow,
      });
    }

    // input change
    handleInputChange = (value,field) =>{
      // 最小起订量控制
      if(field === 'orderQuantity'){
          value = (value < this.state.minBuyNumber) ? this.state.minBuyNumber : value;
      }

      this.setState({
        [field]: value
      });
    }

    // select change
    handleSelectChange = (value,field)=> {
      this.setState({
        [field]: value
      },()=>{
        // option切换后，获取当前sku的价格
        let variantTitleArr = [];
        let variantTitle = '';
        if(this.state.selectOptionOne !== ''){
          variantTitleArr.push(this.state.selectOptionOne);
        }
        if(this.state.selectOptionTwo !== ''){
          variantTitleArr.push(this.state.selectOptionTwo);
        }
        if(this.state.selectOptionThree !== ''){
          variantTitleArr.push(this.state.selectOptionThree);
        }

        if(variantTitleArr.length === 1){
          variantTitle = variantTitleArr.join();
        }
        if(variantTitleArr.length >= 2){
          variantTitle = variantTitleArr.join(' / ');
        }
        
        if(variantTitle !== ''){
          let array = this.state.variants;
          for (let i = 0; i < array.length; i++) {
             if(variantTitle === array[i].variant_title){
                this.setState({
                  currentVariantId: array[i].id,
                  currentVariantTitle: array[i].variant_title,
                  currentVariantPrice: array[i].price,
                  orderQuantity: this.state.minBuyNumber,
                });
                break;
             }
          }
        }
      });
    }

    // + 添加购物车
    handleAddToCart = () =>{
      let beAddedInfo = {
        id: this.props.id,
        variant_id: this.state.currentVariantId,
        title: this.state.currentVariantTitle,
        price: this.state.currentVariantPrice,
        quantity: this.state.orderQuantity,
      };
      let data = this.state.createOrderArray;
      if(data.length === 0){
        data.push(beAddedInfo);
      } else {
        // 判断当前的sku,是否存在
        let isNotIn = true;
        for (let i = 0; i < data.length; i++) {
          if(data[i].variant_id === beAddedInfo.variant_id){
            isNotIn = false;
            // 追加数量
            data[i].quantity = Number(data[i].quantity) + Number(beAddedInfo.quantity);
            break;
          }
        }

        if(isNotIn){
          data.push(beAddedInfo);
        }
      }

      this.setState({
        createOrderArray: data
      },()=>{
        // 更新购物车
        this.updateCartList()
      });
    }

    // - 移除选择项购物车
    handleRemoveFromCart = (recordKey) =>{
      let data = this.state.createOrderArray;
      if(data.length>0){
        data.splice(recordKey,1);

        this.setState({
          createOrderArray: data
        },()=>{
          // 更新购物车
          this.updateCartList()
        });
      }
    }

    // 更新购物车数据列表
    updateCartList(){
      let data = this.state.createOrderArray;
      let trHtmlContent = <tr></tr>;
      let total = 0;
      if(data.length > 0){
        trHtmlContent = data.map((item,key) => {
          let single = '';
          // 价格计算
          let singleTotal = Number(item.price) * Number(item.quantity);
          total += singleTotal;

          single = (
            <tr className="border-top border-bottom" key={key}>
              <td colSpan="2">
                <div className="item__title">
                  {item.title}
                </div>
                <div>
                  <Button variant='plain' size="slim" onClick={()=>this.handleRemoveFromCart(key)}>{intl.get("Remove")}</Button>
                </div>
              </td>
              <td>{'$'+item.price}</td>
              <td className="text-center">{item.quantity}</td>
              <td className="text-right">{'$'+this.handleFormatMoney(singleTotal,2)}</td>
            </tr>
          );

          return (
            single
          )
        });
      }

      this.setState({
        Subtotal: total,
        cartViewHtml: trHtmlContent
      });
    }

    // 格式化金额显示
    handleFormatMoney(s, type) {
      if (/[^0-9.]/.test(s))
        return "0";
      if (s === null || s === "")
        return "0";
      s = s.toString().replace(/^(\d*)$/, "$1.");
      s = (s + "00").replace(/(\d*.\d\d)\d*/, "$1");
      s = s.replace(".", ",");
      var re = /(\d)(\d{3},)/;
      while (re.test(s))
        s = s.replace(re, "$1,$2");
      s = s.replace(/,(\d\d)$/, ".$1");
      if (type === 0) {  // 不带小数位(默认是有小数位)
        var a = s.split(".");
        if (a[1] === "00") {
          s = a[0];
        }
      }
      return s;
    }

    // 提示跳转弹窗
    handleLeavingModal = () =>{
      this.setState({
        leavingModalActive:!this.state.leavingModalActive,
      });
    }

    // create order 确认生成订单
    handleCreateOrder = async () =>{
      this.setState({handleLoading: true});
      const params = {
        id: this.props.id,
        cart: JSON.stringify(this.state.createOrderArray),
      }

      const response = await reqPostCreatePackageOrder(params)
      this.setState({
        handleLoading: false,
      });
      if(response.code==='200'){

        // this.toggleToast(response.msg, false);
        // 关闭弹窗
        this.handleChangeModal();

        // 提示跳转弹窗
        this.handleLeavingModal();
        
      }else{
        this.toggleToast(response.msg);
      }
    }

    render() {
      const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;
      const {
          state: { 
            ModalShow,handleLoading,Title,ImageList,labelArray,valuesArray,selectOptionOne,selectOptionTwo,selectOptionThree,currentVariantPrice,minBuyNumber,orderQuantity,
            cartViewHtml,Subtotal,leavingModalActive
          },
      } = this;

      const isLeaveingModal = (
        <Modal
          open={leavingModalActive}
          onClose={this.handleLeavingModal}
          title={intl.get("Create Order")}
          primaryAction={{
            content: intl.get('Go to order page'),
            url:'/admin/order_list'
          }}
          secondaryActions={[
            {
              content: intl.get('Cancel'),
              onAction: this.handleLeavingModal,
            },
          ]}
        >
          <Modal.Section>
             
              <p>
                {intl.get('You have successfully created an order, please pay at Order > Order List > Unpaid.')}
              </p>
             
          </Modal.Section>
        </Modal>
      );

      const ModalContent = (
        <section>
          <Layout>
            <Layout.Section>
              <section className="Product_Detail_Content">

                <div className="Product_Detail_Img">
                  {/* <img src={ImageUrl} alt="" /> */}
                  <ImageGalleryShow images={ImageList} showThumbnails={true} isshowFullscreenButton={true}/>
                </div>

                <div className="Product_Detail_Box">
                  <div className="space"></div>
                  <FormLayout>
                    
                    <Text variant="headingMd" as="h2">{Title}</Text>

                    <FormLayout.Group condensed>
                      {(valuesArray[0].length > 0) ? (
                        <Select
                          id="selectOptionOne"
                          label={labelArray[0]}
                          options={valuesArray[0]}
                          onChange={this.handleSelectChange}
                          value={selectOptionOne}
                        />
                        ) : ''
                      }
                      {(valuesArray[1].length > 0) ? (
                        <Select
                          id="selectOptionTwo"
                          label={labelArray[1]}
                          options={valuesArray[1]}
                          onChange={this.handleSelectChange}
                          value={selectOptionTwo}
                        />
                        ) : ''
                      }
                      {(valuesArray[2].length > 0) ? (
                        <Select
                          id="selectOptionThree"
                          label={labelArray[2]}
                          options={valuesArray[2]}
                          onChange={this.handleSelectChange}
                          value={selectOptionThree}
                        />
                        ) : ''
                      }
                    </FormLayout.Group>

                    <div className="Add_To_Cart">
                      <BlockStack alignment="center">
                        <span className="Price_Sale">{'$'+currentVariantPrice}</span>
                        <span className="Quantity_Unit"><Icon source={CancelSmallMinor} /></span>
                        <div className="Pre_Order_Quantity">
                          <TextField
                            id="orderQuantity"
                            type="number"
                            value={String(orderQuantity)}
                            onChange={this.handleInputChange}
                            step={5}
                            min={minBuyNumber}
                          />
                        </div>
                        <div className="Add_To_Button">
                          <Button icon={CirclePlusMajor} onClick={this.handleAddToCart}></Button>
                        </div>
                      </BlockStack>
                    </div>


                  </FormLayout>
                </div>
              </section>

              <div className="Cart_Box" style={{display:(Subtotal > 0) ? 'block' : 'none'}}>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan="2">{intl.get("Select item")}</th>
                        <th>{intl.get("Price")}</th>
                        <th className="text-center">{intl.get("Quantity")}</th>
                        <th className="text-right">{intl.get("Total")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* 购物车列表 */}
                      {cartViewHtml}
                    </tbody>
                  </table>
                </div>

                <div className="Cart__Footer">
                  <div className="Cart__Subtotal text-right">
                    <div>
                      <span className="cart__subtotal-title">{intl.get("Subtotal")}</span>
                      <span className="cart__subtotal">
                        <span className="money">
                          {'$'+FormatMoney(Subtotal,2)+'USD'}
                        </span>
                      </span>
                    </div>
                  </div>

                </div>
                <div style={{clear: 'both'}}></div>

              </div>


            </Layout.Section>
          </Layout>
        </section>
      );
    
      return (
          <div>
            <Modal
              open={ModalShow} 
              onClose={this.handleChangeModal} 
              title={intl.get("Custom packaging")}
              primaryAction={
                {
                  content: intl.get("Create"),
                  onAction: this.handleCreateOrder,
                  loading: handleLoading,
                  disabled: (Subtotal > 0) ? false : true
                }
              } 
              secondaryActions={[{
                content: intl.get("Cancel"),
                onAction: this.handleChangeModal
              }]}
              loading={this.state.loadingPage}
              size='large'
            >
              <Modal.Section>
                
                {/* 内容 */}
                {ModalContent}

              </Modal.Section>
            </Modal>

            {/* 下单成功后，是否跳转到订单页面 */}
            {isLeaveingModal}

            { toastMarkup }
          </div>
      );

      // 格式化金额显示
      function FormatMoney(s, type) {
        if (/[^0-9.]/.test(s))
          return "0";
        if (s === null || s === "")
          return "0";
        s = s.toString().replace(/^(\d*)$/, "$1.");
        s = (s + "00").replace(/(\d*.\d\d)\d*/, "$1");
        s = s.replace(".", ",");
        var re = /(\d)(\d{3},)/;
        while (re.test(s))
          s = s.replace(re, "$1,$2");
        s = s.replace(/,(\d\d)$/, ".$1");
        if (type === 0) {  // 不带小数位(默认是有小数位)
          var a = s.split(".");
          if (a[1] === "00") {
            s = a[0];
          }
        }
        return s;
      }
    }
}

export default PackageDetailModal;